import { useMemo } from "react";
import { useNotificationContext } from "providers/NotificationProvider";
import { useInboxBadge } from "views/inbox/api/use-inbox-badge";
import { useNeedsLockboxCount } from "shared/hooks/use-needs-lockbox-count";
import { NavItemId } from "./constants";
import { useRentReportingNavCount } from "./use-rent-reporting-nav-count";

const MAX_BADGE_COUNT = 99;

export const formatNavBadgeCount = (count: number) =>
  count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count);

export const useNavItemCounts = ({
  isInboxEnabled,
  isUnitsEnabled
}: {
  isInboxEnabled: boolean;
  isUnitsEnabled: boolean;
}) => {
  const { totalUnread } = useNotificationContext();
  const { badge: inboxBadge } = useInboxBadge(isInboxEnabled);
  const rentReportingCount = useRentReportingNavCount();
  const unitsCount = useNeedsLockboxCount({ enabled: isUnitsEnabled });

  return useMemo(
    () =>
      new Map<NavItemId, number>([
        [NavItemId.NOTIFICATIONS, totalUnread],
        [NavItemId.INBOX, inboxBadge.total],
        [NavItemId.UNITS, unitsCount],
        [NavItemId.RENT_REPORTING, rentReportingCount]
      ]),
    [totalUnread, inboxBadge.total, unitsCount, rentReportingCount]
  );
};
